import { useRef } from 'react'

// Shared by the expert-report and suppliers/customers balance summary/statement/opening-balance queries: true when
// react-query's `keepPreviousData` is serving stale rows because a non-page identity param (period/filters/search/contact)
// changed, not because of a page-only change. Errors don't settle the identity (`lastSettledIdentity` only updates
// off `isPreviousData`), so a failed refetch keeps this true and a tracking settle-effect never fires a stale
// `resultsCount` for it.
export const useIsFetchingNewParams = (identityParams: Record<string, unknown>, isPreviousData: boolean): boolean => {
  const keyIdentity = JSON.stringify(identityParams)
  const lastSettledIdentity = useRef(keyIdentity)
  if (!isPreviousData) {
    lastSettledIdentity.current = keyIdentity
  }

  return isPreviousData && lastSettledIdentity.current !== keyIdentity
}

export const useIsFetchingNewPeriod = (period: string | undefined, isPreviousData: boolean): boolean =>
  useIsFetchingNewParams({ period }, isPreviousData)
